import * as React from "react";
import { asThemeConsumer } from "../../../../theme/Theme";
import { joinClasses } from "../../../../utils/Filters";
/**
 *
 * @param props
 */
var FlexColumnComp = function (props) {
    var appColumnClassName = "scl-b-app__column";
    var pageClassName = (!!props.isPage ? "scl-b-app__column--page" : undefined);
    var isFixedClassName = (!!props.isFixed ? "scl-b-app__column--fixed" : undefined);
    var hasScrollableClassName = (!!props.hasScrollable ? "scl-b-app__column--has-scrollable" : undefined);
    var className = joinClasses(props.className || "", "scl-h-background", appColumnClassName, pageClassName, isFixedClassName, hasScrollableClassName);
    return (React.createElement("div", { style: props.style, className: className }, props.children));
};
/**
 *
 */
export var FlexColumn = asThemeConsumer(FlexColumnComp);
